import React, { Component } from 'react';
import styled from 'styled-components';

const Screen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 80px, rgb(248, 249, 250) 80px, rgb(248, 249, 250) 160px)',
  height: 100vh;
  padding: 30px;
  box-sizing: border-box;
`

class Limitations extends Component {

  render() {
    return (
      <Screen>
        <img src="https://cdn.shopify.com/s/files/1/1887/3517/files/FTPrints_Logo_400px_2x_b6eb6f60-6a65-4288-829b-24f31ce3fea9_400x200.png?v=1490939637" />
        <p>In order to use the Family Tree Prints chart maker, please use Chrome, Firefox, or Safari browsers on a laptop or desktop computer.</p>
      </Screen>
    );
  }
}

export default Limitations;



// WEBPACK FOOTER //
// ./src/containers/Limitations.js